export default __webpack_public_path__ + "static/assets/3d3a92f00cd1b3a18d1bce3795eff913.svg";